import { createContext, useContext } from 'react'
import fetch from 'cross-fetch'
import queryString from 'query-string'

const PwaKitUrlUtils = require('pwa-kit-react-sdk/utils/url')

import PageDesignerConfig from '@service/CMSApiClient.types'

class CMSApiClient {
  locale: string

  config: PageDesignerConfig

  constructor(config: PageDesignerConfig, locale: string) {
    this.config = config
    this.locale = locale
  }

  async cmsApiFetch(
    endpoint: string,
    method: string,
    params: any,
    body: any
  ): Promise<any> {
    const config = this.config
    const locale = this.locale
    const { proxyPath } = config
    const host = `${PwaKitUrlUtils.getAppOrigin()}${proxyPath}`
    const baseUrl = `${host}/${config.parameters.subPath}${
      !config.parameters.langAsParam
        ? `/${
            config.parameters.localeToLang[locale]
              ? config.parameters.localeToLang[locale]
              : 'default'
          }`
        : ''
    }/api/content${endpoint}`

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...config.headers
    }

    params = params ? params : {}

    if (config.parameters.langAsParam) {
      params.lang = config.parameters.localeToLang[locale]
    }

    const response = await fetch(
      `${baseUrl}?${queryString.stringify(params)}`,
      {
        method: method,
        headers: headers,
        ...(body && {
          body: JSON.stringify(body)
        })
      }
    )

    if (response.status >= 400) {
      throw new Error(
        'Bad response from the server! Status Code: ' +
          response.status +
          ' - Message: ' +
          response.statusText
      )
    }

    return response.json()
  }

  getPageByIdOrSlug(pageIdOrSlug: string): Promise<any> {
    const endpoint = `/get`
    const method = 'GET'
    const body = null

    const params = {
      pageIdOrSlug: pageIdOrSlug
    }

    return this.cmsApiFetch(endpoint, method, params, body)
  }
}

const CMSApiContext = createContext(null)
const CMSApiProvider = CMSApiContext.Provider
const useCMSApi = () => useContext(CMSApiContext)

export { CMSApiClient, CMSApiContext, CMSApiProvider, useCMSApi }
